import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  createUser,
  getAllUsers,
  updateUser,
} from "../../../actionCreator/userManagementActionCreator";
import { countries } from "../../../constant/Countries";
import { userType } from "../../../constant/WebToLead";
import { useAlert } from "../../../context/AlertProvider";

export const useCreateEditUser = () => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [isTeamChange, setTeamChange] = useState(false);

  const handleCreateUpdateUser = async (values, initialValues, callback) => {
    setLoading(true);
    setError();
    const [firstName, lastName] = values?.fullName
      ? values?.fullName.trim().split(" ")
      : ["", ""];
    const payload = {
      ...values,
      firstName,
      lastName: lastName || "",
      mobileNo:
        "+" +
        countries?.find((d) => d?.label === values?.prefix)?.code +
        " " +
        values?.mobileNo,
      userType: userType.NATIVE,
    };

    const res = initialValues?.id
      ? await dispatch(updateUser({ ...payload, id: initialValues?.id }))
      : await dispatch(createUser(payload));

    if (res.status === 201 || res.status === 200) {
      if (initialValues?.id) {
        showAlert(
          "success",
          `${values?.fullName}'s details have been updated successfully!`
        );
      } else {
        showAlert("success", "User created successfully!");
      }
      callback();
      dispatch(getAllUsers({ page: page ? page - 1 : 0 }));
    } else {
      if (res?.response?.data?.errorKey !== "teamChangeNotConfirmed") {
        setError(res?.response?.data?.title);
        showAlert("error", res?.response?.data?.title);
      } else {
        setTeamChange(true);
      }
    }
    setLoading(false);
  };

  return {
    error,
    loading,
    handleCreateUpdateUser,
    setError,
    isTeamChange,
    setTeamChange,
  };
};
